import { IKnm248 } from 'APIPackage/KnmModule/interfaces/IKnm248';
import { convertFormDateTimeValueToKnmDataDate } from 'KnmPackage/MainModule/common/convertFormDateTimeValueToKnmDataDate';

import { IKnmErknmForm } from '../interfaces/IKnmErknmForm';
import { convertSignersFormToData } from './convertSignersFormToData';

type DataType = IKnm248['decision'];

export const convertDecisionFormValuesToKnmData = (values: IKnmErknmForm) => {
  const {
    dateTimeDecision,
    numberDecision,
    placeDecision,
    fioSigner,
    titleSigner,
    notInFIAS: isNotInFIAS,
    region,
    manualAddress,
    fiasRegion,
    kindKnm,
    decisionDisabled: isDecisionDisabled,
    disabledDecisionMessage,
    decisionSystemSignatureUsed: isDecisionSystemSignatureUsed,
    decisionSystemSignatureDateTime,
    decisionSystemSignatureMnemonic,
    decisionSystemSignatureTitle,
    signers,
  } = values;
  const data: DataType = {
    dateTimeDecision: convertFormDateTimeValueToKnmDataDate(dateTimeDecision),
    numberDecision: numberDecision || null,
    placeDecision: placeDecision || null,
    fioSigner: fioSigner || null,
    titleSigner: !titleSigner?.value
      ? null
      : {
          ...titleSigner.value,
          inspectionResult: titleSigner.inspectionResult,
        },
    notInFIAS: isNotInFIAS || null,
    region: region?.id?.toString() || null,
    manualAddress: manualAddress || null,
    fiasRegion: fiasRegion?.id.toString() || null,
    decisionDisabled:
      // eslint-disable-next-line no-nested-ternary
      typeof isDecisionDisabled !== 'boolean'
        ? typeof kindKnm?.decisionDisabled === 'boolean'
          ? kindKnm?.decisionDisabled
          : null
        : isDecisionDisabled,
    disabledDecisionMessage:
      // eslint-disable-next-line no-nested-ternary
      typeof isDecisionDisabled !== 'boolean'
        ? typeof kindKnm?.decisionDisabled === 'boolean'
          ? kindKnm?.disabledDecisionMessage
          : null
        : disabledDecisionMessage || null,
    systemSignatureDateTime: decisionSystemSignatureDateTime || null,
    systemSignatureMnemonic: decisionSystemSignatureMnemonic || null,
    systemSignatureTitle: decisionSystemSignatureTitle || null,
    systemSignatureUsed: isDecisionSystemSignatureUsed || false,
    signers: convertSignersFormToData(signers),
  };

  return data;
};
